import React from 'react';
import { Action, createLocalContextWithActionHandlers } from 'App/helpers/stateHelper';
import { Actions } from './Actions';
export { type Dispatch } from 'App/helpers/stateHelper';
import type Client from 'App/resources/Model/Client';
import type ProspectingClient from 'App/resources/Model/ProspectingClient';
import type SoliditetClient from 'App/resources/Model/SoliditetClient';
import { TABS } from '../Tabs/Tabs';

type SelectableClient = Client & { title: string };

export type AddState = {
	activeTab: TABS;
	searchQuery: string;
	selectedClients: SelectableClient[];
	selectedBranches: ProspectingClient[] | SoliditetClient[];
	filteredBranchOffices: ProspectingClient[] | SoliditetClient[];
	selectableCompanies: SelectableClient[];
	nonSelectableCompanies: SelectableClient[];
	showPreview: boolean;
	saving: boolean;
	isProspecting: boolean;
};

const ACTION_HANDLERS: { [key: string]: (s: AddState, a: Action) => AddState } = {
	[Actions.SET_ACTIVE_TAB]: (state, { activeTab }) => ({
		...state,
		activeTab
	}),
	[Actions.SET_SEARCH_QUERY]: (state, { searchQuery }) => ({
		...state,
		searchQuery
	}),
	[Actions.SET_SELECTED_CLIENTS]: (state, { selectedClients }) => ({
		...state,
		selectedClients
	}),
	[Actions.SET_SELECTED_BRANCHES]: (state, { selectedBranches }) => ({
		...state,
		selectedBranches
	}),
	[Actions.SET_FILTERED_BRANCH_OFFICES]: (state, { filteredBranchOffices }) => ({
		...state,
		filteredBranchOffices
	}),
	[Actions.SET_SHOW_PREVIEW]: (state, { showPreview }) => ({
		...state,
		showPreview
	}),
	[Actions.SET_SAVING]: (state, { saving }) => ({
		...state,
		saving
	}),
	[Actions.DESELECT_CLIENT]: (state, { selectedClients }) => ({
		...state,
		selectedClients
	}),
	[Actions.SELECT_CLIENT]: (state, { selectedClients }) => ({
		...state,
		selectedClients
	}),
	[Actions.DESELECT_ALL]: state => ({
		...state,
		searchQuery: '',
		activeTab: TABS.ALL_COMPANIES,
		selectedClients: [],
		selectedBranches: [],
		filteredBranchOffices: []
	}),
	[Actions.SET_COMPANIES]: (state, { selectableCompanies, nonSelectableCompanies }) => ({
		...state,
		selectableCompanies,
		nonSelectableCompanies
	})
};

const { Provider, useDispatch, useSelector } = createLocalContextWithActionHandlers(ACTION_HANDLERS);
export const useAddDispatch = useDispatch;
export const useAddSelector = useSelector;

export function AddProvider({ children, isProspecting }: { children: React.ReactNode; isProspecting: boolean }) {
	const initialState: AddState = {
		activeTab: TABS.ALL_COMPANIES,
		searchQuery: '',
		selectedClients: [],
		selectedBranches: [],
		filteredBranchOffices: [],
		selectableCompanies: [],
		nonSelectableCompanies: [],
		showPreview: false,
		saving: false,
		isProspecting
	};

	return <Provider value={initialState}>{children}</Provider>;
}
